import images from "./images";

const About = {
  sub: "About Us",
  heading: "Where Innovation Meets Possibility",
  description: [
    "Empowering a Transformative Tomorrow through Innovative Artificial Intelligence",
    "At TechNova, we're driven by the power of artificial intelligence to create a brighter future. Lorem ipsum dolor sit amet consectetur adipisicing elit. Eum voluptatibus dolores aspernatur animi perferendis iste! Culpa aut enim debitis optio illum ipsum quis perferendis dolor expedit."
  ],
  points: [
    "Pioneering AI Solutions",
    "Transforming Industries",
    "Empowering Businesses",
    "Driving Innovation Forward"
  ],
  image: {
    src: images.about,
    alt: "About-Image",
  },
  button: {
    text: "Learn More",
    link: "Services",
  },
};

export default About;